SNI.Application.addModule('image-embed', context => {

  return {
    behaviors: ['social-pinterest']
  };

});
